import React, { forwardRef, useCallback, useContext, useMemo, useRef, } from 'react';
import { CnPageFooter } from '@/components/cn-page-footer';
import { List } from './components/list';
import { ListSubCard } from './components/list-sub-card';
import { Toolbar } from './components/toolbar';
import { CardItemsContext, CardItemsStateCtx } from './context/card-items';
import { useIsInCard } from './hooks/use-is-in-card';
const Content = () => {
    const state = useContext(CardItemsStateCtx);
    const { isInCard, conRef } = useIsInCard();
    if (isInCard)
        return React.createElement(ListSubCard, null);
    return (React.createElement("div", { ref: conRef, className: "cn-ui-m-card-items-container" },
        React.createElement(List, null),
        state.showToolbar ? (React.createElement(CnPageFooter, null,
            React.createElement(Toolbar, { ...state }))) : null));
};
export const Container = forwardRef((props, ref) => {
    return (React.createElement(CardItemsContext, { tableProps: props, ref: ref },
        React.createElement(Content, null)));
});
// @ts-ignore 该逻辑后期会下线
Container.useRemote = () => {
    const ref = useRef({});
    const refresh = useCallback(async () => {
        if (!ref?.current?.refresh)
            return;
        await ref.current.refresh();
    }, []);
    const load = useCallback(async () => {
        if (!ref?.current?.load)
            return;
        await ref.current.load();
    }, []);
    return useMemo(() => ({ ref, refresh, load }), [refresh, load]);
};
// @ts-ignore 该逻辑后期会下线
Container.createRemoteInstance = () => {
    const ref = {
        current: {},
    };
    const refresh = async () => {
        if (!ref?.current?.refresh)
            return;
        await ref.current.refresh();
    };
    const load = async () => {
        if (!ref?.current?.load)
            return;
        await ref.current.load();
    };
    return { ref, refresh, load };
};
